import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { IOrdersListItem } from '../../../interfaces';
import { useOrdersTable, useProfileIsRight, useUiIsLoading, useUiSearch } from '../../../hooks';
import { lightText, stringMoney } from '../../../instruments';
import { tF, tI } from '../../../translate';
import { Catcher, LinkComponent, TableItemToolbar, columnToolbar } from '../../../Components';
import '../../../customStyle/table.less';
import Styles from '../../styles/m_viewStyles.less';

export const OrdersTableList: React.FC = observer(() => {
    const isLoading = useUiIsLoading();
    const list = useOrdersTable();
    const search = useUiSearch();
    const isLord = useProfileIsRight('LORD');

    const tableColumns = [
        {
            title: tF('ID'),
            dataIndex: 'idLink',
        },
        {
            title: tF('Date'),
            dataIndex: 'dateLink',
        },
        {
            title: tF('Company'),
            dataIndex: 'companyLink',
        },
        {
            title: tF('User'),
            dataIndex: 'userLink',
        },
        {
            title: tF('Payment Method'),
            dataIndex: 'paymentType',
        },
        {
            title: tF('Description'),
            dataIndex: 'descriptionLink',
        },
        {
            title: tF('Cost'),
            dataIndex: 'costText',
            className: Styles.columnRight,
        },
        {
            title: tF('Status'),
            dataIndex: 'status',
            className: Styles.columnRight,
        },
        columnToolbar,
    ];
    const tableData = list.map((order: IOrdersListItem) => {
        return {
            key: order.id,
            ...order,
            idLink: <LinkComponent currentListComponent={'OrdersList'} id={order.id} />,
            dateLink: <LinkComponent currentListComponent={'OrdersList'} id={order.id} name={order.updatedAt} />,
            descriptionLink: order.description ? (
                <LinkComponent currentListComponent={'OrdersList'} id={order.id} isLight name={order.description} />
            ) : null,
            companyLink: (
                <LinkComponent
                    currentListComponent={'CompaniesList'}
                    id={order?.companyId?.id}
                    isLight
                    name={order?.companyId?.name}
                />
            ),
            userLink: (
                <LinkComponent
                    currentListComponent={'UsersList'}
                    id={order?.user?.id}
                    isLight
                    name={order?.user?.name}
                />
            ),
            paymentType: lightText(order.paymentTypeId, search),
            status: lightText(order.status, search),
            costText: stringMoney(order.amount, order?.currencyId?.abbreviation),
            toolbar: (
                <TableItemToolbar id={order?.id || ''} itemName={`"${order.id}" ${tI('order')}`} isEdit={isLord} />
            ),
        };
    });

    return (
        <Catcher>
            <div className={Styles.tablePlace}>
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    size={'middle'}
                />
            </div>
        </Catcher>
    );
});
